import * as z from "zod";

const EstablishmentBadgeSchema = z.object({
  ImageUrl: z.url(),
  Url: z.url().nullable(),
});

export const EstablishmentSchema = z.object({
  Id: z.guid(),
  ShortName: z.string(),
  FullName: z.string(),
  CNPJ: z.string(),
  AvatarUrl: z.url(),
  LogoUrl: z.url(),
  FaviconUrl: z.url(),
  Color: z.string(),
  Badges: z.array(EstablishmentBadgeSchema).optional().default([]),
});
